import { Directive, effect, HostListener, input, OnDestroy, output } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[unityDebounceValueChanges]',
  standalone: true,
})
export class DebounceValueChangesDirective<T> implements OnDestroy {
  public readonly $debounceDelay = input(800, { alias: 'debounceDelay' });
  public readonly debouncedValueChange = output<T>();

  private stream: Subject<T> = new Subject<T>();
  private subscription?: Subscription;

  public constructor() {
    effect(() => {
      const valueChangeDelay = this.$debounceDelay();

      this.subscription?.unsubscribe();

      this.subscription = this.stream.pipe(debounceTime(valueChangeDelay)).subscribe((value: T) => {
        return this.debouncedValueChange.emit(value);
      });
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  @HostListener('valueChange', ['$event'])
  public onValueChange(value: Event): void {
    this.stream.next(value as T);
  }
}
